$(document).ready(function () {
    console.log("ready!"), $("form.Form input.Form__Input-search").focusin(function () {
        console.log("input focus started"), $(".header_search-submit").removeClass("header_search-submit-hide"), $(".header_form-wrapper").removeClass("form-border-no"), $(".header_form-wrapper").addClass("form-border-yes")
    }), $("form.Form input").focusout(function () {
        if ($(this).val() == '') {
            $(".header_search-submit").addClass("header_search-submit-hide"), $(".header_form-wrapper").removeClass("form-border-yes"), $(".header_form-wrapper").addClass("form-border-no")
        }
    })
});

